var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterExam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 101"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 33.5,
    height: 33.5,
    rx: 16.75,
    fill: "#2F75DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.27539 16.701H9.39436C10.0533 16.701 10.3828 16.701 10.677 16.832C10.9712 16.963 11.1985 17.2108 11.6529 17.7064L12.8398 19.0009C13.2391 19.4364 13.4387 19.6541 13.6819 19.6371C13.925 19.6202 14.0949 19.3767 14.4346 18.8897L18.2087 13.4787C18.5618 12.9725 18.7383 12.7194 18.9885 12.7075C19.2386 12.6955 19.4368 12.9307 19.833 13.4011L21.6809 15.5947C22.1396 16.1392 22.3689 16.4115 22.6761 16.5562C22.9832 16.701 23.3315 16.701 24.0281 16.701H27.0685",
    stroke: "white",
    strokeWidth: 1.73276,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterExam);
export default __webpack_public_path__ + "static/media/afterExam.66fd4dc662a9cda4bf829215cb2e836e.svg";
export { ForwardRef as ReactComponent };